
import objectPath from 'object-path'
import router from '@/router'
import Session from '@/utils/session'
import profileInitialState from '@/store/modules/profile/initialState'
import { account } from '@/utils/mapping'

const mutations = {
  setFormField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  login(state, payload) {
    const { apiKey } = payload

    Session.setSecret(apiKey)

    state.apiKey = apiKey
    state.access = true

    router.push({ name: 'Main' })
  },
  logout(state) {
    Session.destroy()

    state.apiKey = null
    state.access = false

    this.state.profile = profileInitialState()

    router.push({ name: 'Login' })
  },
  setLoginError(state, payload) {
    state.loginFormErrors = payload.map(item => account.loginErrors(item))

    if (payload[0].code === 400 && payload[0].source === 'password') {
      state.loginFormErrors.push({
        field: 'login',
        message: ' '
      })
    }
  },
  setAccess(state, { name: roleName }) {
    const roles = {
      GUEST: 'Guest',
      SUBAGENCY_MANAGER: 'SubAgencyManager',
      SUBAGENCY_ADMIN: 'SubAgencyAdmin',
      AGENCY_MANAGER: 'AgencyManager',
      AGENCY_ADMIN: 'AgencyAdmin',
      OPERATOR_MANAGER: 'OperatorManager',
      OPERATOR_ADMIN: 'OperatorAdmin',
      ONEX_MANAGER: 'OnexManager',
      ONEX_DIRECTOR: 'OnexDirector',
      ONEX_ADMIN: 'OnexAdmin',
      DEVELOPER: 'Developer',
      OBSERVER: 'Observer',
      SEARCH_ENGINE: 'SearchEngine',
      OVC_DIRECTOR: 'OvcDirector',
      OVC_MANAGER: 'OvcManager',
      OVC_COURIER: 'OvcCourier',
      FIT_MANAGER: 'FitManager',
      B2C_CLIENT: 'B2bClient',
      RE_MANAGER: 'ReManager'
    }

    this.commit(`account/set${roles[roleName]}Access`)
  },
  setGuestAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForAgents: false,
      favorites: false,
      lk: false,
      booking: false,
      agencyPrice: false,
      orders: false,
      editSale: false,
      editEvents: false,
      editBanner: false
    }
  },
  setSubAgencyManagerAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false,
      editSale: false,
      editEvents: false,
      editBanner: false,
      phonesForIndividuals: false
    }
  },
  setSubAgencyAdminAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false,
      editSale: false,
      editEvents: false,
      editBanner: false,
      phonesForIndividuals: false
    }
  },
  setAgencyManagerAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false,
      editSale: false,
      editEvents: false,
      editBanner: false,
      phonesForIndividuals: false
    }
  },
  setAgencyAdminAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false,
      editSale: false,
      editEvents: false,
      editBanner: false,
      phonesForIndividuals: false
    }
  },
  setOperatorManagerAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setOperatorAdminAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setOnexManagerAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setOnexDirectorAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setOnexAdminAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setDeveloperAccess(state) {
    state.accesses = {
      ...state.accesses,
      main: true,
      nestedForGuests: false,
      nestedForIndividuals: false,
      editSale: false,
      agencyPrice: false,
      editBanner: false,
      phonesForIndividuals: false
    }
  },
  setObserverAccess(state) {
    state.accesses = {
      ...state.accesses,
      // ???
    }
  },
  setSearchEngineAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setOvcDirectorAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setOvcManagerAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setOvcCourierAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setFitManagerAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForIndividuals: false
    }
  },
  setB2bClientAccess(state) {
    state.accesses = {
      ...state.accesses,
      nestedForGuests: false,
      nestedForAgents: false,
      agencyPrice: false,
      editSale: false,
      editEvents: false,
      editBanner: false,
      phonesForAgents: false
    }
  },
  setReManagerAccess(state) {
    state.accesses = {
      ...state.accesses,
      // ???
    }
  },
}

export default mutations